import { MissionTypeObjective } from "@/components/missions-render-v1/missions-render-types";
import ProgressBar from "@/components/progress-bar/progress-bar";
import { ObjectiveSocialMedia } from "../../objective-social-media-type";
import TPremiaCard from "@/components/t-premia-card/t-premia-card";
import { ContentObjectiveStyled, ContentTitleStyled, TitleStyled } from "./style-component";
import { Avatar } from "antd";
import LikeIcon from '@/assets/icons/like/like/like.component.svg';
import { tPremiaGreen } from "@/contexts/theme-context/config/colorPalette";
import { CheckOutlined } from "@ant-design/icons";

const ALLOWED_OBJECTIVES: Partial<Record<MissionTypeObjective, (quantity: number) => string>> = {
  'GET_LIKES': (quantity) => `Obtén ${quantity} reacciones`,
  'GET_COMMENTS': (quantity) => `Obtén ${quantity} comentarios`,
  'GET_SHARES': (quantity) => `Comparte ${quantity} veces`,
  'GET_VIEWS': (quantity) => `Obtén ${quantity} vistas`,
}

const ICONS: Partial<Record<MissionTypeObjective, string>> = {
  'GET_LIKES': LikeIcon,
  'GET_COMMENTS': LikeIcon,
  'GET_SHARES': LikeIcon,
  'GET_VIEWS': LikeIcon,
}

const ObjectiveProgress: React.FC<{objective: Omit<ObjectiveSocialMedia['objective'],"isComingSoon">, position: number, disabledMission: boolean}> = ({ objective, position, disabledMission }) => {
	const { type, participant_progress } = objective;
  const { current_progress } = participant_progress ?? {};

  const objectiveType = type?.split(':')[0] as MissionTypeObjective;
	if (!Object.keys(ALLOWED_OBJECTIVES).includes(objectiveType)) {
		return null;
	}
  const title = ALLOWED_OBJECTIVES[objectiveType];
  const { quantity } = objective;
  const completed = current_progress && current_progress >= quantity;
  const temp1 = current_progress && current_progress > 0 ? 'inCourse' : 'expired';
  const status = completed ? 'completed' : temp1;

  /*
  window.localStorage.setItem('currentReactions', current_progress?.toString() ?? '0');
  window.localStorage.setItem('totalReactions', quantity.toString());
  window.localStorage.setItem('typeReaction', 'reacciones');*/

	return (
    <TPremiaCard variant="dark" style={{ gap: '0px', padding: '0px', margin: '0px' }}>
      <ContentObjectiveStyled $disabledMission={disabledMission}>
        <ContentTitleStyled>
          <TitleStyled $completed={Boolean(completed)}>
            <span>{position}.</span> {title?.(quantity)}
          </TitleStyled>
          {!completed ? <Avatar src={ICONS[objectiveType]} shape="square" alt="icon" /> :
          <CheckOutlined  style={{ color: tPremiaGreen, fontSize: '2rem' }}/>}
        </ContentTitleStyled>
        <ProgressBar progress={current_progress ?? 0} isExChange={true} maxProgress={quantity} status={status} />
      </ContentObjectiveStyled>
    </TPremiaCard>
  )
}

export default ObjectiveProgress;
